import { Component, ElementRef, Input, NgZone, OnInit, Output, QueryList, ViewChild, EventEmitter, ViewChildren } from '@angular/core';
import { FormControl, Validators, FormArray, FormGroup } from '@angular/forms';
import { Address } from '@models/peripherals/address';
import { AddressForm } from '@models/peripherals/address-form';
import { AgmCoreModule, MapsAPILoader } from '@agm/core';
// import { } from '@types/googlemaps';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MapPopupComponent } from '../../../shared/map-popup/map-popup.component';
import { Router } from '@angular/router';
import { ConfirmPopupComponent } from '@shared/modal-popup/confirm-popup/confirm-popup.component';
@Component({
  selector: 'app-addressarray',
  templateUrl: './addressarray.component.html',
  styleUrls: ['./addressarray.component.css']
})
export class AddressarrayComponent implements OnInit {
  @ViewChild('search') public searchElementRef: QueryList<ElementRef>;
  @ViewChild(MapPopupComponent) mapModal: MapPopupComponent;
  @ViewChild(ConfirmPopupComponent) confirmModal: ConfirmPopupComponent;
  public latitude: number[] = [];
  public longitude: number[] = [];
  public currentAddress: string[] = [];
  zoom: number;
  public isCollapsed = true;
  private addressType: string[];
  selectColor = '#aaaaaa';
  locationCounter: number;
  anothername = '';
  addanothername = '';
  addressTypes = [];
  isfocus = false;

  @Input()
  public addressForm: AddressForm[];

  @Input()
  public addressFormArray: FormArray;

  @Input()
  public addTypes: any[];

  @Input()
  public parentId: number;

  @Output() deleteAddressEvent: EventEmitter<number> = new EventEmitter();

  static buildAddresses() {
    return new FormArray([
      this.buildAddress(''),
    ]);
  }

  static buildFormAddress(val: AddressForm): any {
    return new FormGroup({
      address_id: new FormControl(val.addressId),
      location: new FormControl(val.location),
      address_type_id: new FormControl(val.type),
      address_about_it: new FormControl(val.about),
      address1: new FormControl(val.address1),
      address2: new FormControl(val.address2),
      city: new FormControl(val.city),
      zip: new FormControl(val.zip),
      state: new FormControl(val.state),
      country: new FormControl(val.country),
      latitude: new FormControl(val.latitude),
      longitude: new FormControl(val.longitude),
      street_no: new FormControl(val.street_no)
    });
  }

  static buildAddress(val: string): any {
    return new FormGroup({
      address_id: new FormControl(null),
      location: new FormControl(val),
      address_type_id: new FormControl(null),
      address_about_it: new FormControl(val),
      address1: new FormControl(null),
      address2: new FormControl(null),
      city: new FormControl(null),
      zip: new FormControl(null),
      state: new FormControl(null),
      country: new FormControl(null),
      latitude: new FormControl(null),
      longitude: new FormControl(null),
      street_no: new FormControl(null)
    });
  }
  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private router: Router) { }
  ngOnInit() {
    if (this.router.url.includes('opportunities')) {
      this.anothername = 'Construction Site';
      this.addanothername = 'ADD CONSTRUCTION SITE';
      this.addTypes.filter(item => {
        if (item.address_category ===  'oppty') {
          this.addressTypes.push(item);
        }
      });
    } else {
      this.anothername = 'Location';
      this.addanothername = 'ADD LOCATION';
      this.addTypes.filter(item => {
        if (item.address_category ===  'org_con') {
          this.addressTypes.push(item);
        }
      });
    }
    if (this.addressForm) {
      
      this.addressFormArray.removeAt(0);
      this.addressForm.forEach(element => {
        this.selectColor = '#000000';
        let addr = (element.street_no == null ? '' : element.street_no + ', ') +
          (element.address1 == null ? '' : element.address1 + ', ') + (element.address2 == null ? '' : element.address2 + ', ') +
          (element.city == null ? '' : element.city + ', ') + (element.state == null ? '' : element.state + ', ') +
          (element.country == null ? '' : element.country + ', ') + (element.zip == null ? '' : element.zip);
        addr = addr.replace(/,(\s+)?$/, '');
        if (this.parentId) {
          this.latitude.push(Number(element.latitude));
          this.longitude.push(Number(element.longitude));
          this.currentAddress.push(addr);
        }
        this.addressFormArray.push(AddressarrayComponent.buildFormAddress(element));
      });
    }
    this.locationCounter = this.addressForm.length;
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(<HTMLInputElement>document.getElementById('location0'), {
        types: ['address'],
        componentRestrictions: { country: 'us' }
      });

      if(sessionStorage.getItem('Orgdata')){
        this.isfocus = true;
      }

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          let addressData = this.createAddressData(place);
          this.insertAddressDataInFormGroup(0, addressData);

          let addr1 = (addressData['street_no'] == null ? '' : addressData['street_no'] + ', ') +
            (addressData['address1'] == null ? '' : addressData['address1'] + ', ') + (addressData['address2'] == null ? '' :
              addressData['address2'] + ', ') + (addressData['city'] == null ? '' : addressData['city'] + ', ') +
            (addressData['state'] == null ? '' : addressData['state'] + ', ') + (addressData['country'] == null ? '' :
              addressData['country'] + ', ') + (addressData['zip'] == null ? '' : addressData['zip']);
          addr1 = addr1.replace(/,(\s+)?$/, "");

          this.latitude.push(place.geometry.location.lat());
          this.longitude.push(place.geometry.location.lng());
          this.currentAddress.push(addr1);
          this.zoom = 15;
        });
      });
    });
  }

  addAddress() {
    this.addressFormArray.push(AddressarrayComponent.buildAddress(null));
    this.locationCounter = this.locationCounter + 1;
    this.isCollapsed = false;
    setTimeout(() => { this.autocomplete(); }, 1000);
  }

  changetxtRecord() {
    this.selectColor = '#000000';
  }
  autocomplete() {
    this.mapsAPILoader.load().then(() => {
      const eleLen = document.getElementsByClassName('input-location').length - 1;
      for (let j = 0; j <= eleLen; j++) {
        const autocomplete = new google.maps.places.Autocomplete(<HTMLInputElement>document.getElementById('location' + j), {
          types: ['address'],
          componentRestrictions: { country: 'us' }
        });
        autocomplete.addListener('place_changed', () => {
          this.ngZone.run(() => {
            // get the place result
            const place: google.maps.places.PlaceResult = autocomplete.getPlace();
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }
            let addressData = this.createAddressData(place);
            this.insertAddressDataInFormGroup(j, addressData);

            let addr2 = (addressData['street_no'] == null ? '' : addressData['street_no'] + ', ') +
              (addressData['address1'] == null ? '' : addressData['address1'] + ', ') + (addressData['address2'] == null ? '' :
                addressData['address2'] + ', ') + (addressData['city'] == null ? '' : addressData['city'] + ', ') +
              (addressData['state'] == null ? '' : addressData['state'] + ', ') + (addressData['country'] == null ? '' :
                addressData['country'] + ', ') + (addressData['zip'] == null ? '' : addressData['zip']);
            addr2 = addr2.replace(/,(\s+)?$/, "");

            // set latitude, longitude and zoom
            this.latitude.push(place.geometry.location.lat());
            this.longitude.push(place.geometry.location.lng());
            this.currentAddress.push(addr2);
            this.zoom = 15;
          });
        });
      }
    });
  }
  showMap(latitude, longitude, address) {
    if (latitude !== undefined || longitude !== undefined) {
      this.mapModal.showModalAddress(latitude, longitude, address);
    }
  }

  createAddressData(place) {
    let addressData = {};
    for (var ac = 0; ac < place.address_components.length; ac++) {
      var component = place.address_components[ac];
      switch (component.types[0]) {
        case "route":
          addressData['address1'] = component.long_name;
          break;

        case "sublocality_level_2":
          addressData['address2'] = component.long_name;
          break;

        case "sublocality_level_1":
          if (addressData['address2']) {
            addressData['address2'] = addressData['address2'] + ", " + component.long_name;
          } else {
            addressData['address2'] = component.long_name;
          }

          break;

        case "postal_code":
          addressData['zip'] = component.long_name;
          break;

        case 'locality':
          addressData['city'] = component.long_name;
          break;

        case 'administrative_area_level_1':
          addressData['state'] = component.long_name;
          break;
        case 'country':
          addressData['country'] = component.long_name;
          break;
        case "street_number":
          addressData['street_no'] = component.long_name;
          break;
      }
    };

    addressData['latitude'] = place.geometry.location.lat();
    addressData['longitude'] = place.geometry.location.lng();
    return addressData;
  }

  insertAddressDataInFormGroup(index, addressData) {
    this.addressFormArray.controls[index].get('address1').setValue(addressData['address1'])
    this.addressFormArray.controls[index].get('address2').setValue(addressData['address2'])
    this.addressFormArray.controls[index].get('zip').setValue(addressData['zip'])
    this.addressFormArray.controls[index].get('city').setValue(addressData['city'])
    this.addressFormArray.controls[index].get('state').setValue(addressData['state'])
    this.addressFormArray.controls[index].get('country').setValue(addressData['country'])
    this.addressFormArray.controls[index].get('latitude').setValue(addressData['latitude'])
    this.addressFormArray.controls[index].get('longitude').setValue(addressData['longitude'])
    this.addressFormArray.controls[index].get('street_no').setValue(addressData['street_no'])
  }

  deleteAddress(index) {
    let addressId = this.addressFormArray.controls[index.map_id].get('address_id').value;
    if (this.parentId) {
      this.deleteAddressEvent.emit(addressId);
      this.addressFormArray.removeAt(index.map_id);
      this.confirmModal.closeModal();
    } else {
      this.addressFormArray.removeAt(index.map_id);
      this.confirmModal.closeModal();
    }
    this.locationCounter = this.locationCounter - 1;
  }
  onLocationChange(address) {
    address.controls['latitude'].setValue(null, { onlySelf: true });
    address.controls['longitude'].setValue(null, { onlySelf: true });
  }

  openConfirm(id) {
    this.confirmModal.showModal(id);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form-control/address-form-control/addressarray.component.ts